import { createSelector } from 'reselect'

const selector = state => state.preferredLanesReducer

export const preferredLaneDataSelector = createSelector(
  [selector],
  ({ preferredLanes }) => preferredLanes
)

export const preferredLaneGetSelector = createSelector(
  [selector],
  ({ fethLoading, preferredLanesAlreadyLoaded, fethError }) =>
    ({ fethLoading, preferredLanesAlreadyLoaded, fethError })
)

export const preferredLaneAddSelector = createSelector(
  [selector],
  ({ addLoading, addError }) =>
    ({ addLoading, addError })
)

export const preferredLaneEditSelector = createSelector(
  [selector],
  ({ editLoading, editError }) =>
    ({ editLoading, editError })
)

export const preferredLaneDeleteSelector = createSelector(
  [selector],
  ({ deleteLoading, deleteError }) =>
    ({ deleteLoading, deleteError })
)

export const preferredLaneSelector = createSelector(
  [selector],
  preferredLane => preferredLane
)
